import Choices from 'choices.js';
class ComponentFilterAnnuaireSelect {
  constructor() {
    this._init();
  }

  _init() {
    const filterEntrepriseSelect = document.getElementById("filter-select-annuaire__select--entreprise") as HTMLSelectElement;
    const filterServiceSelect = document.getElementById("filter-select-annuaire__select--service") as HTMLSelectElement;

    if (filterEntrepriseSelect) {
      new Choices(filterEntrepriseSelect, {
        searchEnabled: false,
        searchChoices: false,
        itemSelectText: '',
      });
      filterEntrepriseSelect.addEventListener("change", () => {
        const selectedValue = filterEntrepriseSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set("entreprise", selectedValue);
        window.location.href = url.toString();
      });
    }
    if (filterServiceSelect) {
      new Choices(filterServiceSelect, {
        searchEnabled: false,
        searchChoices: false,
        itemSelectText: '',
      });
      filterServiceSelect.addEventListener("change", () => {
        const selectedValue = filterServiceSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set("service", selectedValue);
        window.location.href = url.toString();
      });
    }

  }
}

export const componentFilterAnnuaireSelect = new ComponentFilterAnnuaireSelect();
